export default __webpack_public_path__ + "static/media/study-app.351f2bd2.png";